type EditorContext = {
  readonly: boolean;
  studentEditor?: boolean;
};

export function guideOverlayText(ctx: EditorContext, text: string) {
  if (ctx.readonly || ctx.studentEditor) {
    return;
  }
  return text;
}

export function showGuideMediaActions(ctx: EditorContext) {
  return !ctx.readonly && !ctx.studentEditor;
}
